// FormularioPlataforma.mjs
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useClientNavigation } from '../hooks/useClientNavigation.mjs';
import { styles } from '../styles/form.mjs';
import { apiUrl3 } from '../api/client.mjs';

const FormularioPlataforma = () => {
    const { navigateToClient } = useClientNavigation();
    const { id } = useParams();
    const clienteId = process.env.REACT_APP_CLIENT_ID;
    const [plataforma, setPlataforma] = useState({
        url: '',
        ordem: 0
    });

    useEffect(() => {
        if (id) {
            const url = apiUrl3(id)
            axios.get(url)
                .then(response => {
                    const { url, ordem } = response.data;
                    setPlataforma({
                        url: url || '',
                        ordem: ordem || 0
                    });
                })
                .catch(error => console.error('Erro ao buscar detalhes da plataforma:', error));
        } else {
            const url = apiUrl3('')
            axios.get(url)
                .then(response => {
                    const maxOrder = response.data.reduce((max, item) => Math.max(max, item.ordem), 0);
                    setPlataforma(plat => ({ ...plat, ordem: maxOrder + 1 }));
                })
                .catch(error => console.error('Erro ao buscar a máxima ordem existente:', error));
        }
    }, [id, clienteId]);

    const handleCancel = () => {
        navigateToClient('/plataformas');
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const data = { ...plataforma };
        const urlEndpoint = id ? apiUrl3(id) : apiUrl3('');

        axios({
            method: id ? 'put' : 'post',
            url: urlEndpoint,
            data
        })
            .then(() => navigateToClient('/plataformas'))
            .catch(error => console.error("Operation failed: ", error));
    };

    return (
        <form onSubmit={handleSubmit} style={styles.form}>
            <label style={styles.label}>Plataforma ou Mensagem</label>
            <textarea
                style={styles.textarea}
                value={plataforma.url}
                onChange={(e) => setPlataforma({ ...plataforma, url: e.target.value })}
            />
            <button style={styles.button} type="submit">Salvar</button>
            <button onClick={handleCancel} style={styles.buttonCancel}>Cancelar</button>
        </form>
    );
};

export default FormularioPlataforma;
